//NOTE: https://github.com/machadop1407/custom-use-fetch-hook-react/blob/main/src/App.js

import { useEffect, useState } from "react";
import axiosClient from "../HTTPServices/apiClient";

function useFetch(urlPostFix) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("useFetch Load ------------> " + urlPostFix);

    setLoading(true);
    // axios
    //   .get(url)
    axiosClient
      .get("/" + urlPostFix)
      .then((response) => {
        setData(response.data.responseObj);
        //  debugger;
        console.log(
          "Response: ===== > " +
            urlPostFix +
            " ---- " +
            JSON.stringify(response.data.responseObj)
        );
      })
      .catch((err) => {
        setError(err);
        console.log("Error : ===== > " + urlPostFix + " ---- " + err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [urlPostFix]);

  // const refetch = () => {
  //   setLoading(true);
  //   axios
  //     .get(url)
  //     .then((response) => {
  //       setData(response.data);
  //     })
  //     .catch((err) => {
  //       setError(err);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  return { data, loading, error };
}

export default useFetch;
